/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { BookingFromJSON, BookingToJSON, BookingPublicFromJSON, BookingPublicToJSON, BookingPublicV2FromJSON, BookingPublicV2ToJSON, } from '../models/index';
/**
    * Converts a number to a padded string
    * @param num The number to stringify
    * @param size Number of total digits
    */
function pad(num, size) {
    let negative = num < 0;
    if (negative) {
        num *= -1;
    }
    let numString = num.toString();
    while (numString.length < size)
        numString = "0" + numString;
    return (negative ? "-" : "") + numString;
}
/**
    * Returns a date in the RFC3339 format, e.g.: 2016-01-19T15:21:32.59+02:00
    * @param dateTime
    */
export function toRFC3339(dateTime) {
    let rfcWithoutTimeoffset = `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1, 2)}-${pad(dateTime.getDate(), 2)}T${pad(dateTime.getHours(), 2)}:${pad(dateTime.getMinutes(), 2)}:${pad(dateTime.getSeconds(), 2)}${dateTime.getMilliseconds() != 0 ? "." + pad(dateTime.getMilliseconds(), 3) : ""}`;
    let timeOffsetString;
    let to = dateTime.getTimezoneOffset() * -1;
    let toh = Math.floor(to / 60);
    let tom = to % 60;
    if (tom < 0) {
        tom *= -1;
    }
    timeOffsetString = pad(toh, 2) + ":" + pad(tom, 2);
    return rfcWithoutTimeoffset + (toh > 0 ? "+" : "") + timeOffsetString;
}
/**
 *
 */
export class BookingApi extends runtime.BaseAPI {
    /**
     * Retrieve the active (or for that matter concluded booking) booking for the given id. This can be used to enforce reading a specific active booking for continuity reasons
     */
    async activebookingBookingIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling activebookingBookingIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-APP-ID"] = await this.configuration.apiKey("X-APP-ID"); // AppId authentication
        }
        const response = await this.request({
            path: `/activebooking/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BookingPublicV2FromJSON(jsonValue));
    }
    /**
     * Retrieve the active (or for that matter concluded booking) booking for the given id. This can be used to enforce reading a specific active booking for continuity reasons
     */
    async activebookingBookingIdGet(requestParameters, initOverrides) {
        const response = await this.activebookingBookingIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Move the booking along the statuses
     */
    async bookingBookingIdCmdPostRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingBookingIdCmdPost().');
        }
        if (requestParameters['cmd'] == null) {
            throw new runtime.RequiredError('cmd', 'Required parameter "cmd" was null or undefined when calling bookingBookingIdCmdPost().');
        }
        const queryParameters = {};
        if (requestParameters['cmd'] != null) {
            queryParameters['cmd'] = requestParameters['cmd'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/booking/{bookingId}/{cmd}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Move the booking along the statuses
     */
    async bookingBookingIdCmdPost(requestParameters, initOverrides) {
        await this.bookingBookingIdCmdPostRaw(requestParameters, initOverrides);
    }
    /**
     * Retrieve a specific booking
     */
    async bookingBookingIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingBookingIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/booking/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BookingFromJSON(jsonValue));
    }
    /**
     * Retrieve a specific booking
     */
    async bookingBookingIdGet(requestParameters, initOverrides) {
        const response = await this.bookingBookingIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * End the specified booking
     */
    async bookingEndBookingIdPostRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingEndBookingIdPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/booking/end/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * End the specified booking
     */
    async bookingEndBookingIdPost(requestParameters, initOverrides) {
        await this.bookingEndBookingIdPostRaw(requestParameters, initOverrides);
    }
    /**
     * Confirm a booking request for the slot
     */
    async bookingrequestConfirmBookingIdPostRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingrequestConfirmBookingIdPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bookingrequest/confirm/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BookingFromJSON(jsonValue));
    }
    /**
     * Confirm a booking request for the slot
     */
    async bookingrequestConfirmBookingIdPost(requestParameters, initOverrides) {
        const response = await this.bookingrequestConfirmBookingIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Cancel the specified booking request (as a advertiser) or reject it as a game company
     */
    async bookingrequestEndBookingIdPostRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling bookingrequestEndBookingIdPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bookingrequest/end/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Cancel the specified booking request (as a advertiser) or reject it as a game company
     */
    async bookingrequestEndBookingIdPost(requestParameters, initOverrides) {
        await this.bookingrequestEndBookingIdPostRaw(requestParameters, initOverrides);
    }
    /**
     * Retrieve all booking requests visible to the logged in user
     */
    async bookingrequestsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bookingrequests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BookingFromJSON));
    }
    /**
     * Retrieve all booking requests visible to the logged in user
     */
    async bookingrequestsGet(initOverrides) {
        const response = await this.bookingrequestsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Retrieve all bookings visible to the logged in user
     */
    async bookingsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/bookings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BookingFromJSON));
    }
    /**
     * Retrieve all bookings visible to the logged in user
     */
    async bookingsGet(initOverrides) {
        const response = await this.bookingsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Retrieve an active booking for this slot to be displayed in game. The service decides which one based on allocated budget etc.
     * @deprecated
     */
    async slotBookingSlotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling slotBookingSlotIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-APP-ID"] = await this.configuration.apiKey("X-APP-ID"); // AppId authentication
        }
        const response = await this.request({
            path: `/slot/booking/{slotId}`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BookingPublicFromJSON(jsonValue));
    }
    /**
     * Retrieve an active booking for this slot to be displayed in game. The service decides which one based on allocated budget etc.
     * @deprecated
     */
    async slotBookingSlotIdGet(requestParameters, initOverrides) {
        const response = await this.slotBookingSlotIdGetRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }
    /**
     * Retrieve an active booking for this slot to be displayed in game. The service decides which one based on allocated budget etc.
     */
    async slotSlotIdActivebookingGetRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling slotSlotIdActivebookingGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-APP-ID"] = await this.configuration.apiKey("X-APP-ID"); // AppId authentication
        }
        const response = await this.request({
            path: `/slot/{slotId}/activebooking`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BookingPublicV2FromJSON(jsonValue));
    }
    /**
     * Retrieve an active booking for this slot to be displayed in game. The service decides which one based on allocated budget etc.
     */
    async slotSlotIdActivebookingGet(requestParameters, initOverrides) {
        const response = await this.slotSlotIdActivebookingGetRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }
    /**
     * Create a booking request for the slot
     */
    async slotSlotIdBookingRequestPostRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling slotSlotIdBookingRequestPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/slot/{slotId}/booking/request`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingToJSON(requestParameters['booking']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BookingFromJSON(jsonValue));
    }
    /**
     * Create a booking request for the slot
     */
    async slotSlotIdBookingRequestPost(requestParameters, initOverrides) {
        const response = await this.slotSlotIdBookingRequestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve all bookings for a slot
     */
    async slotSlotIdBookingsGetRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling slotSlotIdBookingsGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/slot/{slotId}/bookings`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BookingFromJSON));
    }
    /**
     * Retrieve all bookings for a slot
     */
    async slotSlotIdBookingsGet(requestParameters, initOverrides) {
        const response = await this.slotSlotIdBookingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const BookingBookingIdCmdPostCmdEnum = {
    End: 'end',
    Pause: 'pause',
    Restart: 'restart'
};
